import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a08b52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents-html" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "heaer-address" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_6 = { class: "video-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_video_class_header = _resolveComponent("video-class-header")!
  const _component_video_goods_line = _resolveComponent("video-goods-line")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_current_address, null, {
            address: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" > 机械原理动画 ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_video_class_header, { onChangeSort: _ctx.changeSort }, null, 8, ["onChangeSort"]),
      _createVNode(_component_video_goods_line, {
        goodsList: _ctx.allGoodsList.data,
        loadingType: _ctx.allGoodsList.loading
      }, null, 8, ["goodsList", "loadingType"]),
      (_ctx.classList.datas.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.classList.datas, (classinfo, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(_component_video_class_header, {
                isShowMore: true,
                "header-type": 2,
                classinfo: classinfo,
                cindex: index,
                checkedClassItem: _ctx.checkedClass[index],
                onChangeClass: _ctx.changeClass,
                onChangeSort: _ctx.changeSort
              }, null, 8, ["classinfo", "cindex", "checkedClassItem", "onChangeClass", "onChangeSort"]),
              _createVNode(_component_video_goods_line, {
                goodsList: classinfo.goodslist,
                loadingType: classinfo.loading
              }, null, 8, ["goodsList", "loadingType"])
            ], 64))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_html_footer)
  ]))
}